// extracted by mini-css-extract-plugin
module.exports = {"refresh":"RefreshName-module--refresh--16SPx"};